import { render, staticRenderFns } from "./CompanyNew.vue?vue&type=template&id=59908e97"
import script from "./CompanyNew.vue?vue&type=script&lang=js"
export * from "./CompanyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports